"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsList = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var PermissionsMember_1 = require("./PermissionsMember");
var PermissionsTeam_1 = require("./PermissionsTeam");
var PermissionsRoleTeam_1 = require("./PermissionsRoleTeam");
var usePermissionObject_1 = require("./usePermissionObject");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var PermissionsEveryoneTeam_1 = require("./PermissionsEveryoneTeam");
var PrivateBanner_1 = require("./PrivateBanner");
var PermissionsListLoading = function () {
    return (React.createElement(react_1.Flex, { direction: "column", marginY: 1 }, __spreadArray([], Array(5), true).map(function (_, i) { return (React.createElement(react_1.HStack, { key: i, spacing: 4, marginY: 1 },
        React.createElement(react_1.SkeletonCircle, { size: "10" }),
        React.createElement(react_1.SkeletonText, { noOfLines: 2, w: "50%" }),
        React.createElement(react_1.Spacer, null),
        React.createElement(react_1.SkeletonText, { noOfLines: 1, w: "20%" }))); })));
};
var NoPermissions = function () {
    var _js = (0, usePermissionsModalContext_1.usePermissionsModalContext)()._js;
    // There is no access granted to this object, so how did the user get here?
    // Getting here should be impossible, but just in case...
    return (React.createElement(react_1.Flex, { justifyContent: "center", alignItems: "center", height: "100%", direction: "column", paddingY: 4 },
        React.createElement(react_1.Text, { variant: "muted" }, _js('No access currently granted.'))));
};
var PermissionsTeams = function (_a) {
    var teams = _a.teams, roleTeams = _a.roleTeams;
    return (React.createElement(react_1.SimpleGrid, { spacing: 2, id: "permissions-modal-teams" },
        roleTeams.map(function (roleTeam) { return (React.createElement(PermissionsRoleTeam_1.PermissionsRoleTeam, { key: roleTeam.roleTeamName, roleTeam: roleTeam })); }),
        React.createElement(PermissionsEveryoneTeam_1.PermissionsEveryoneTeam, null),
        teams.map(function (team) { return (React.createElement(PermissionsTeam_1.PermissionsTeam, { key: "team-".concat(team.team.teamid), team: team })); })));
};
var PermissionsMembers = function (_a) {
    var members = _a.members;
    return (React.createElement(react_1.SimpleGrid, { spacing: 2, id: "permissions-modal-users" }, members.map(function (member) { return (React.createElement(PermissionsMember_1.PermissionsMember, { key: "user-".concat(member.user.userid), member: member })); })));
};
var PermissionsList = function () {
    var _a, _b;
    var _c = (0, usePermissionObject_1.usePermissionObject)(), objectType = _c.objectType, objectId = _c.objectId;
    var usePermissions = (0, usePermissionsModalContext_1.usePermissionsModalContext)().usePermissions;
    var _d = usePermissions(objectType, objectId), permissions = _d.data, isLoading = _d.isLoading;
    var hasPermissions = Boolean((permissions === null || permissions === void 0 ? void 0 : permissions.roleTeams.length) ||
        (permissions === null || permissions === void 0 ? void 0 : permissions.teams.length) ||
        (permissions === null || permissions === void 0 ? void 0 : permissions.users.length) ||
        (permissions === null || permissions === void 0 ? void 0 : permissions.privacyStatus));
    if (isLoading) {
        return React.createElement(PermissionsListLoading, null);
    }
    if (!hasPermissions) {
        return React.createElement(NoPermissions, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(PrivateBanner_1.PrivateBanner, null),
        React.createElement(PermissionsTeams, { teams: (_a = permissions === null || permissions === void 0 ? void 0 : permissions.teams) !== null && _a !== void 0 ? _a : [], roleTeams: (_b = permissions === null || permissions === void 0 ? void 0 : permissions.roleTeams) !== null && _b !== void 0 ? _b : [] }),
        Boolean((permissions === null || permissions === void 0 ? void 0 : permissions.roleTeams.length) || (permissions === null || permissions === void 0 ? void 0 : permissions.teams.length)) && React.createElement(react_1.Divider, { my: 2 }),
        React.createElement(PermissionsMembers, { members: (permissions === null || permissions === void 0 ? void 0 : permissions.users) || [] })));
};
exports.PermissionsList = PermissionsList;
